import * as currencySymbolMap from 'currency-symbol-map/map';
import { OfferedAsType, } from '@wix/bookings-uou-types';
import { PaymentDtoMapper } from '../payment/payment-dto.mapper';
const currencyFixesOverrides = {
    KZT: '₸',
    LBP: 'ل.ل.', // TODO: remove when we create and merge PR
};
const fixedCurrencySymbolMap = {
    ...currencySymbolMap,
    ...currencyFixesOverrides,
};
export class PriceMapper {
    constructor({ servicePaymentDto, offeredAs, locale = 'en', regionalSettingsLocale = 'en', isUseIntlForPriceInBookFlowEnabled = false, formatter = (key) => key, }) {
        this.servicePaymentDto = servicePaymentDto;
        this.offeredAs = offeredAs;
        this.locale = locale;
        this.regionalSettingsLocale = regionalSettingsLocale;
        this.isUseIntlForPriceInBookFlowEnabled =
            isUseIntlForPriceInBookFlowEnabled;
        this.formatter = formatter;
    }
    getPriceBy(locale, currencyDisplay = 'symbol') {
        if (this.shouldShowPlanText()) {
            return this.servicePaymentDto.displayTextForPlan;
        }
        if (this.shouldShowOfferingPrice()) {
            if (this.isUseIntlForPriceInBookFlowEnabled) {
                try {
                    const paymentDtoMapper = new PaymentDtoMapper(locale, this.formatter);
                    return paymentDtoMapper.getFormattedPrice(this.servicePaymentDto, currencyDisplay);
                }
                catch (e) {
                    console.error('Failed to format price: ', e);
                    return this.getFallbackFormattedPrice();
                }
            }
            return this.getFallbackFormattedPrice();
        }
        if (this.shouldShowFreeOfferingText()) {
            return this.servicePaymentDto.priceText;
        }
        return '';
    }
    getText() {
        return this.getPriceBy(this.regionalSettingsLocale);
    }
    getAriaLabel() {
        return this.getPriceBy(this.locale, 'name');
    }
    getFallbackFormattedPrice() {
        const symbol = fixedCurrencySymbolMap[this.servicePaymentDto.currency];
        return `${symbol}${this.formattedPrice()}`;
    }
    shouldShowPlanText() {
        return (this.offeredAs.indexOf(OfferedAsType.PRICING_PLAN) > -1 &&
            this.servicePaymentDto.displayTextForPlan);
    }
    shouldShowOfferingPrice() {
        return !this.servicePaymentDto.isFree && this.servicePaymentDto.price;
    }
    shouldShowFreeOfferingText() {
        return (this.offeredAs.indexOf(OfferedAsType.PRICING_PLAN) <= -1 &&
            this.servicePaymentDto.isFree);
    }
    formattedPrice() {
        const price = Number(this.servicePaymentDto.price);
        return price.toFixed(PriceUtils.getFractionDigits(price));
    }
}
export class ServicePaymentDtoFactory {
    static fromOfferingDto(catalogServiceDto) {
        return {
            currency: catalogServiceDto.payment.currency,
            price: catalogServiceDto.payment.price,
            isFree: catalogServiceDto.payment.isFree,
            isVariedPricing: catalogServiceDto.payment.isVariedPricing,
            priceText: catalogServiceDto.payment.priceText,
            minCharge: catalogServiceDto.payment.minCharge,
            paymentType: catalogServiceDto.payment.paymentType,
            displayTextForPlan: catalogServiceDto.pricingPlanInfo
                ? catalogServiceDto.pricingPlanInfo.displayText
                : '',
        };
    }
}
export class PriceUtils {
    static getFractionDigits(price) {
        return price % 1 === 0 ? 0 : 2;
    }
    static validateCurrencyCode(currencyCode) {
        const currencyCodeFormat = /^[a-zA-Z]{3}$/;
        return currencyCodeFormat.test(currencyCode);
    }
    static getFormattedCurrency({ price, currencyDisplay = 'symbol', locale, currency, quantity = 1, }) {
        const fractionDigits = PriceUtils.getFractionDigits(price);
        return this.validateCurrencyCode(currency)
            ? Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
                currencyDisplay,
                maximumFractionDigits: fractionDigits,
                minimumFractionDigits: fractionDigits,
            }).format(Number(price * quantity))
            : '';
    }
}
//# sourceMappingURL=price-mapper.js.map